// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"UA-z","expressButtonContainerWithPayPal":"VA-z","expressButton":"WA-z","or":"XA-z"};